import script from "./DirectRebateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectRebateForm.vue?vue&type=script&setup=true&lang=ts"

import "./DirectRebateForm.vue?vue&type=style&index=0&id=55d8d68c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d8d68c"]])

export default __exports__